import * as React from 'react'
import { Col, Row } from 'antd'
import { injectIntl, IntlShape } from 'react-intl'
import styles from './NotFound.module.scss'
import { ReactComponent as NotFoundImage } from '../../assets/img/ic_error.svg'
import Container from '../Container'
import * as AnalyticsManager from '../../lib/analytics/analytics'

class NotFound extends React.Component<NotFoundProps, {}> {
  componentDidMount(): void {
    const { inAnotherPage = false } = this.props
    if (!inAnotherPage) {
      AnalyticsManager.sendCurrentPageView('Not Found')
    }
  }

  render() {
    const { intl: { formatMessage } } = this.props
    const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
    const image = <Row className={styles.image}><NotFoundImage /></Row>
    const title = <Row className={styles.title}>{translate('order_not_found')}</Row>
    const notFound = (
      <Row className={styles.notFound}>
        {image}
        {title}
      </Row>
    )

    return (
      <Container className={styles.notFound}>
        <Col xs={24}>
          {notFound}
        </Col>
      </Container>
    )
  }
}

interface NotFoundProps {
  inAnotherPage?: boolean
  intl: IntlShape
}

export default injectIntl(NotFound)
